import { useState, useEffect } from 'react';
import { getChoosedProducts } from '../../utils/Data/customizeConnector';
import type { ProductChoice } from '../../utils/Data/customizeConnector';

const mapProductsValues = (products: ProductChoice[]) => products.map(
  (product: ProductChoice) => ({ ...product, soldOut: false }),
);

const useUserChoices = () => {
  const [choices, setChoices] = useState<ProductChoice[]>([]);

  useEffect(() => {
    getChoosedProducts()
      .then((response) => {
        if (response.status === 200) {
          const products = mapProductsValues(response.data);
          setChoices(products);
        }
      });
  }, []);

  return choices;
};

export default useUserChoices;
